import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import { toCssClass, toRoman } from 'helpers'

import { MAX_BUILDING_LEVEL } from 'constants'

import styles from './RewardReserve.scss'

export const RewardReserve = (props) => {
    const imageClassName = classNames(
        styles.base,
        styles[`base__${toCssClass(props.type)}`], {
            [styles.base__elite] : props.level > MAX_BUILDING_LEVEL,
            [styles.base__adaptive] : props.adaptive,
        }
    )

    const level = props.showLevel && (
        <span className={styles.level}>
            {toRoman(props.level)}
            <span className={styles.levelGradient}>{toRoman(props.level)}</span>
        </span>
    )

    const tooltipId = `${props.type}_${props.level}_reserve_tooltip_id`

    return (
        <div className={imageClassName} data-tip data-for={tooltipId}>
            {level}
            <span className={styles.counter}>
                {props.count}
            </span>
        </div>
    )
}

RewardReserve.propTypes = {
    level: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired,
    showLevel: PropTypes.bool,
    adaptive: PropTypes.bool,
}

export default RewardReserve



// WEBPACK FOOTER //
// ./components/RewardReserve/RewardReserve.jsx